module.exports = __webpack_public_path__ + "static/media/key.3a74c374.png";